import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '../components/layout';
import SEO from '../components/seo';

const NotFoundPage = () => {
  const data = useStaticQuery(graphql`
    query FourOhFourQuery {
      file(relativePath: { regex: "/error/" }) {
        publicURL
      }
    }
  `);

  return (
    <Layout>
      <SEO title="404: Not found" />
      <ErrorWrapper>
        <RobotImage
          src={data.file.publicURL}
          alt="JustGiving 404 Robo"
          width="400"
        />
        <div>
          <h1>Oops... We couldn't find the page you're looking for</h1>
          <p>That's a bit of a mystery</p>
          <Error>ERROR 404: PAGE NOT FOUND</Error>
          <Link to="/">Go to JustGiving Blog Homepage</Link>
        </div>
      </ErrorWrapper>
    </Layout>
  );
};

export default NotFoundPage;

const ErrorWrapper = styled.div`
  display: flex;
`;

const Error = styled.p`
  text-transform: uppercase;
`;

const RobotImage = styled.img`
  max-width: 41.66667%;
`;
